// Configuration du site PURO — modifiable facilement
// Date officielle d'ouverture du studio (compte à rebours de la homepage)
export const OPENING_DATE = new Date('2026-11-30T09:00:00+01:00');

export const STUDIO_CITY = 'Magalas';
export const CONTACT_EMAIL = 'puropilatesreformer@gmail.com';
export const INSTAGRAM_URL = 'https://www.instagram.com/puropilatesreformer';
export const FACEBOOK_URL = 'https://www.facebook.com/puropilatesreformer';
export const SITE_URL = 'https://puropilatesreformer.com';
